/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

/*-----------
Ajout de Jquery
-----------*/
var script = document.createElement('script');
script.src = 'https://code.jquery.com/jquery-3.4.1.min.js';
script.type = 'text/javascript';
document.getElementsByTagName('head')[0].appendChild(script);





/*-----------
LOADER
-----------*/
function loading() { 
  	
    setTimeout(function () {
        console.log('page is loaded and 1 second has passed'); 
    	$(".loader-wrapper").fadeOut();	
    }, 800);

}


/* fonction qui bloque le scroll */
function disableScroll() { // Récupère la position actuelle du scroll
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,

        // Si l'utilisateur scroll, renvoie aux positions précédemment récupérées
        window.onscroll = function () {
            window.scrollTo(scrollLeft, scrollTop);
        };
};

// Rétablit le scroll
function enableScroll() {
    window.onscroll = function () {};
};

disableScroll(); // Scroll bloqué par défaut


// $(window).on("load", loading); //lors du chargement de la page, execute la fonction loading qui cache le loader
// $(window).on("load", enableScroll); //lors du chargement de la page, execute la fonction enableScroll qui débloque le scroll


document.addEventListener("DOMContentLoaded", function() {
  loading();
  enableScroll();
});



/*-----------
Effet glissement grappes de fond
-----------*/
var position = $(window).scrollTop();

$(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll > position) {
        $('.grape1').css('top', '+=2');
        $('.grape2').css('top', '+=2');
      	$('.grape3').css('top', '+=1');
        $('.grape4').css('top', '+=1');
    } else {
        $('.grape1').css('top', '-=2');
        $('.grape2').css('top', '-=2');
      	$('.grape3').css('top', '-=1');
        $('.grape4').css('top', '-=1');
    }
    position = scroll;
});





/*-----------
Bouton Acheter avec Paypal
-----------*/

function paypalBtn() {
  $('div[data-testid=PayPalInContext-button]').attr('style','text-align: center !important; padding: 10px 30px !important; vertical-align: middle !important; cursor: pointer !important; transition: outline 0.1s linear !important; box-sizing: border-box !important; border-radius: 0 !important; display: inline-block !important; position: relative !important; border: 2px solid #b46318 !important; background-color: #fff !important;');

  $('div[data-testid=PayPalInContext-button] span').attr('style','font-family: "ITC Avant Garde Gothic",sans-serif !important; font-style: normal !important; font-size: 1.2rem !important; font-weight: 700 !important; letter-spacing: 2px !important; text-decoration: none !important; text-transform: uppercase !important; line-height: 2.2 !important; color: #b46318 !important;');

  $('div[data-testid=PayPalInContext-button] svg').attr('style','height: 18px; width: 63.4737px; margin-bottom: -4px;');
}

$(window).on("load", paypalBtn);



